import { useContext, useState, useEffect, Fragment } from "react";

import classes from "./Cabinet.module.css";

import CabinetIngredientBar from "../../components/Cabinet/CabinetIngredientBar/CabinetIngredientBar";
import AddCabinetIngredientCard from "../../components/Cabinet/AddCabIngredientCard/AddCabIngredientCard";
import SearchResultsCard from "../../components/SearchResultsCard/SearchResultsCard";
import LoadingSpinner from "../../UI/LoadingSpinner";
import SubHeader from "../../components/General_Elements/SubHeader/SubHeader";
import CustomButton from "../../components/General_Elements/CustomButton/CustomButton";

import CabinetContext from "../../store/cabinet-context";

import { useHttpClient } from "../../hooks/http-hook";
import useWindowDimensions from "../../hooks/useWindowDimensions";

// page is designed to reflect the ingredients the user has at home
const Cabinet = () => {
  const [addIngredientIsShown, setAddIngredientIsShown] = useState(false); // toggle view to add ingredient to cabinet
  const [loadedCocktails, setLoadedCocktails] = useState([]); // state representing if search results have loaded
  const [showResultsCard, setShowResultsCard] = useState(false); // toggle whether search results are showing on screen
  const { isLoading, sendRequest } = useHttpClient();

  const { width } = useWindowDimensions();

  const cabinetCtx = useContext(CabinetContext);

  // handler to add ingredients to cabinet
  const showAddCabIngredientHandler = () => {
    setAddIngredientIsShown(true);
  };

  // handler to show modal view for adding ingredients to cabinet
  const hideAddCabIngredienteHandler = () => {
    setAddIngredientIsShown(false);
  };

  // handler for showing cocktails from query
  const showResultsCardHandler = () => {
    setShowResultsCard(true);
  };

  // close the modal showing the cocktails from the search
  const hideResultsCardHandler = () => {
    setLoadedCocktails([]);
    setShowResultsCard(false);
  };

  // remove all ingredients from the cabinet
  const clearCabinetHandler = () => {
    cabinetCtx.clearCabinet();
  };

  // check there are items in cabinet before searching backend
  const fetchCocktailsHandler = () => {
    if (cabinetCtx.items.length > 0) {
      fetchCocktails();
    }
  };

  // function that fetches cocktails from backend
  const fetchCocktails = async (instruction) => {
    let ingIDs = [];
    let address = "";

    // ANY - returns all cocktails where at least one ingredient is present in the cabinet
    address = `${process.env.REACT_APP_BACKEND_URL}/cocktails/getAllCocktailsContainingAnyIngredient`;

    // collect all ingredients ID's present in the cabinet
    cabinetCtx.items.forEach((item) => {
      ingIDs.push(item.id);
    });

    // make request to backend for all relevant cocktail for search
    try {
      const responseData = await sendRequest(
        address,
        "POST",
        JSON.stringify({ ingredients: ingIDs }),
        { "Content-Type": "application/json" }
      );
      setLoadedCocktails(responseData.cocktails);
    } catch (err) {}
  };

  // group all alcoholic ingredients and all mixer ingredients and then create display bars for each
  var alcohols = [];
  var mixers = [];

  for (var ing of cabinetCtx.items) {
    if (ing.type_1 === "alcohol") alcohols.push(ing);
    if (ing.type_1 === "mixer") mixers.push(ing);
  }

  var alcoholicIngredients = alcohols.map((ingredient) => {
    return (
      <CabinetIngredientBar
        id={ingredient.id}
        key={ingredient.title}
        title={ingredient.title}
        volume={ingredient.volume}
        image={ingredient.image}
        unit={ingredient.unit}
        type_1={ingredient.type_1}
      />
    );
  });

  var mixerIngredients = mixers.map((ingredient) => {
    return (
      <CabinetIngredientBar
        id={ingredient.id}
        key={ingredient.title}
        title={ingredient.title}
        volume={ingredient.volume}
        image={ingredient.image}
        unit={ingredient.unit}
        type_1={ingredient.type_1}
      />
    );
  });

  // once cocktails are fetched from backend, display these on screen
  useEffect(() => {
    if (loadedCocktails.length > 0) {
      showResultsCardHandler();
    }
  });

  return (
    <div className={classes.cabinet_container}>
      {addIngredientIsShown && (
        <AddCabinetIngredientCard onClose={hideAddCabIngredienteHandler} />
      )}
      {showResultsCard && (
        <SearchResultsCard
          drinks={loadedCocktails}
          onClose={hideResultsCardHandler}
          isSearchQuery={false}
        />
      )}
      {width > 1200 && (
        <img
          className={classes.full_skeleton_left}
          src={"/assets/gen_graphics/full_skeleton_hand.png"}
          alt="new"
          style={{ right: width / 2 + 265 }}
          width="350"
        />
      )}

      <div className={classes.cabinet}>
        {isLoading && <LoadingSpinner asOverlay />}

        <div className={classes.cabinet_ingredients}>
          {alcoholicIngredients.length > 0 && (
            <Fragment>
              <SubHeader title="Alcohol" />
              <div className={classes.ingredients_section}>
                {alcoholicIngredients}
              </div>
            </Fragment>
          )}
          {mixerIngredients.length > 0 && (
            <Fragment>
              <SubHeader title="Mixers" />
              <div className={classes.ingredients_section}>
                {mixerIngredients}
              </div>
            </Fragment>
          )}
        </div>

        <div className={classes.footer}>
          <div className={classes.button_row}>
            <CustomButton
              onClick={showAddCabIngredientHandler}
              content={"ADD INGREDIENT"}
              type={"addButton"}
              width="100%"
              height="100%"
            />
          </div>


          <div className={classes.button_row}>

            <CustomButton
              onClick={() => {
                fetchCocktailsHandler("ANY");
              }}
              content={"SEARCH"}
              type={"searchButton"}
              width="45%"
              height="100%"
            />

            <CustomButton
              onClick={clearCabinetHandler}
              content={"CLEAR"}
              type={"clearButton"}
              width="45%"
              height="100%"
            />
          </div>
        </div>
      </div>
      {width > 1200 && (
        <img
          className={classes.full_skeleton_right}
          src={"/assets/gen_graphics/full_skeleton_hand.png"}
          alt="new"
          style={{ left: width / 2 + 265 }}
          width="350"
        />
      )}
    </div>
  );
};

export default Cabinet;
